import toast from 'react-hot-toast';

export const successToastMessage = (message: string) => {
  toast.success(message);
};

export const errorToastMessage = (message: string) => {
  toast.error(message);
};
